import React, { Component } from 'react'
import '../styles/Landing.css'
import Hero from './Hero'
import {Helmet} from 'react-helmet'
import { injectIntl, defineMessages } from 'react-intl'
import { buildHomeStructuredData } from '../structuredData'

const removeTransition = (element) => {
  if (!element) return
  element.classList.remove("site-transition--visible")
}

const asyncComponent = (loadComponent) => {
  return class AsyncComponent extends Component {
    state = {
      Component: null
    }

    componentDidMount() {
      loadComponent().then((module) => {
        this.setState({ Component: module.default || module })
      })
    }

    render() {
      const LoadedComponent = this.state.Component
      return LoadedComponent ? <LoadedComponent {...this.props} /> : null
    }
  }
}

const ThemesContainer = asyncComponent(() => import('./ThemesContainer'))
const BookingContainer = asyncComponent(() => import('./BookingContainer'))
const SpecialOccasions = asyncComponent(() => import('./SpecialOccasions'))
const Footer = asyncComponent(() => import('./Footer'))

class Landing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDeferredSections: false
    }
  }

  toggleGlitch = () => {
    this.interval = setInterval(() => {
      this.randomizeGlitch()
    }, 1000)
  }

  randomizeGlitch = () => {
    let glitches = document.getElementsByClassName("glitch")
    if (!glitches.length) return

    let glitch = glitches[Math.floor(Math.random() * glitches.length)]
    if (!glitch || !glitch.classList) return

    if (!glitch.classList.contains("glitch--stopped")) {
      window.setTimeout(() => {
        if (!document.body.contains(glitch)) return
        glitch.classList.add("glitch--stopped")
        window.setTimeout(() => {
          if (!document.body.contains(glitch)) return
          glitch.classList.remove("glitch--stopped")
        }, 500)
      }, 10)
    }
  }

  componentDidMount() {
    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      if (!glitchTransition) return
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
    this.toggleGlitch()
    this.deferredSectionsTimeout = window.setTimeout(() => {
      this.setState({ showDeferredSections: true })
    }, 900)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    window.clearTimeout(this.deferredSectionsTimeout)
  }
  render() {
    const {intl:{formatMessage}} = this.props
    const isEn = this.props.lang === 'en' || this.props.intl.locale === 'en'
    const metaTitle = formatMessage(messages.metaTitle)
    const metaDescription = formatMessage(messages.metaDescription)
    return (
      <div className="landing">
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDescription}/>

			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/"/>
			<meta property="og:title" content={metaTitle}/>
			<meta property="og:description" content={metaDescription}/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/OHpresse27.jpg"/>

			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/"/>
			<meta property="twitter:title" content={metaTitle}/>
			<meta property="twitter:description" content={metaDescription}/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/OHpresse27.jpg"/>
			<html lang={isEn ? "en" : "fr"} />
			<link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
            <script type="application/ld+json">{JSON.stringify(buildHomeStructuredData())}</script>
        </Helmet>
        <Hero
          handleLang={(lang) => this.props.handleLang(lang)}
          lang={this.props.lang}
        />
        {this.state.showDeferredSections
          ? <div>
              <ThemesContainer />
              <div id="homepage-booking">
                <BookingContainer
                  expiration={() => this.props.handleExpiration()}
                  lang={this.props.lang}
                />
              </div>
              <SpecialOccasions lang={this.props.lang} />
              <Footer lang={this.props.lang} />
            </div>
          : null
        }
      </div>
    );
  }
}

const messages = defineMessages({
  metaTitle: {
    id: 'landing.metaTitle',
    defaultMessage: 'Escape game Paris - One Hour jeux immersifs à Paris'
  },
  metaDescription: {
    id: 'landing.metaDescription',
    defaultMessage: "Découvrez One Hour escape game Paris, ou jeu d'évasion immersif sur Paris. Entre amis, famille ou comité d'entreprise, nos salles sont ouverts 7j/7"
  },
})

export default injectIntl(Landing)



// WEBPACK FOOTER //
// ./src/components/Landing.js